<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li><span>동의</span></li>
            <li><span>본인인증</span></li>
            <li class="on"><span>결제정보입력 및 확인</span></li>
            <li><span>계약서작성</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">배송정보사항을 확인해주세요.</h2>
          </div>
          <span class="label">설치/배송일</span>
          <div class="setHalf readonly">
            <div class="iptWrap date">
              <!-- <input type="text" id="ipt2_3" class="ipt date notDel uiAct hasDatepicker" title="날짜 선택" value="2017-04-20" readonly="readonly"><button type="button" class="ui-datepicker-trigger"><span class="blind">날짜선택</span></button> -->
              <datepicker
                :value="date"
                :format="format"
                :input-class="inputClass"
                :language="lang"
                :disabled-dates="disabledDate"
                v-model="date"
              ></datepicker>
            </div>
          </div>
          <span class="label">배송연락처</span>
          <span class="singleIpt">
            <input type="checkbox" class="ipt" id="chk1_1" v-model="isInstallData" />
            <label for="chk1_1">주문자의 휴대폰번호와 연락 받을 번호가 다릅니다.</label>
          </span>
          <div class="formArea">
            <span class="label">이름</span>
            <input type="text" id="ipt4" class="ipt" title="이름 입력" v-model="customerName" :disabled="!isInstallData" />

            <span class="label">휴대폰번호</span>
            <input type="tel" id="ipt5" class="ipt" title="휴대폰번호 입력" v-model="cellNum" :disabled="!isInstallData" />

            <!--            <span class="label">주소</span>
            <div class="setAddr">
              <input
                type="tel"
                id="addr_1"
                class="ipt"
                title="설치 주소 입력 (우편번호)"
                placeholder="우편번호"
                value="03142"
                readonly="readonly"
                v-model="installInfo.installAddrPost"
              />
              <button type="button" class="btn_g m" @click="addrPopupOpen">
                우편번호찾기
              </button>
            </div>
            <input
              type="text"
              id="addr_2"
              class="ipt"
              placeholder="기본주소"
              title="설치 주소 입력 (기본주소)"
              value="서울특별시 종로구 종로1길 50"
              readonly="readonly"
              v-model="installInfo.installAddrRoad"
            />
            <input type="text" id="addr_3" class="ipt" placeholder="상세주소" title="설치 주소 입력 (상세주소)" v-model="installInfo.installAddrRemark" />

              <span class="label">{{ prodDetail.releaseClass == 'RDET0001' ? '설치일' : '배송일' }}</span>
              <div class="setHalf readonly">
                  <div class="iptWrap date">
                      &lt;!&ndash; <input type="text" id="ipt2_3" class="ipt date notDel uiAct hasDatepicker" title="날짜 선택" value="2017-04-20" readonly="readonly"><button type="button" class="ui-datepicker-trigger"><span class="blind">날짜선택</span></button> &ndash;&gt;
                      <datepicker
                              :value="date"
                              :format="format"
                              :input-class="inputClass"
                              :language="lang"
                              :disabled-dates="disabledDate"
                              v-model="date"
                      ></datepicker>
                  </div>
              </div>
          --></div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="nextStep">다음</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <FindAddr v-if="findAddr" @callback="selectAddr" @close="close"></FindAddr>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="close">
      <p v-html="msg"></p>
    </ConfirmPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import Datepicker from 'vuejs-datepicker';
import { isEmpty } from '@/common/common.function';
import { ko } from 'vuejs-datepicker/dist/locale';
import MessagePop from '@/components/popup/MessagePop';
import FindAddr from '@/components/comm/FindAddr';
import { GO_HOME } from '@/store/message.type.js';
import ConfirmPop from '@/components/popup/ConfirmPop';
import $ from 'jquery';
export default {
  name: 'guestStep4',
  components: {
    MessagePop,
    Datepicker,
    FindAddr,
    ConfirmPop,
  },
  mounted() {
    $('.btnGoTop').remove();
    this.defaultDate();
    this.request = this.$route.params.request;
    console.log(this.request);
    this.installInfo = this.request.installInfo;

    this.customerName = this.request.conOrderInfo.customerName;
    this.cellNum = this.request.conOrderInfo.cellNum;

    ApiService.service('GET', '/product/' + this.request.orderCommInfo.productCode, {
      params: '',
    })
      .then(({ data }) => {
        this.prodDetail = data.result.productDetail;
        console.log(this.prodDetail);
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
        this.prodDetail = [];
      });
  },
  data: function() {
    return {
      isInstallData: false,
      date: new Date(),
      format: 'yyyy-MM-dd',
      inputClass: 'ipt date notDel uiAct w80',
      calendarClass: 'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all',
      lang: ko,
      flag: true,
      request: null,
      resultPage: 'guestStep6',

      customerName: null,
      cellNum: null,
      disabledDate: {
        to: new Date(),
      },
      prodDetail: [],
      msg: null,
      messagePop: false,
      confirmPop: false,
      findAddr: false,

      // 신용조회 결과
      approvalYN: null,
      tightenYN: null,
      rejectYN: null,
      creditErrorYN: null,
      creditCompletedYN: null,
    };
  },
  watch: {
    isInstallData() {
      console.log(this.isInstallData);
      if (this.isInstallData) {
        this.customerName = '';
        this.cellNum = '';
      } else {
        this.customerName = this.request.conOrderInfo.customerName;
        this.cellNum = this.request.conOrderInfo.cellNum;
      }
    },
  },

  methods: {
    installDataBind: function() {},
    defaultDate: function() {
      let today = new Date();
      let mday = isEmpty(this.prodDetail.deliveryDaysNum) ? 3 : new Number(this.prodDetail.deliveryDaysNum);
      today.setDate(today.getDate() + mday);
      this.date = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
      today = new Date();
      today.setDate(today.getDate() + (mday - 1));
      this.disabledDate.to = today;
    },
    addrPopupOpen: function() {
      this.findAddr = true;
    },
    selectAddr: function(data) {
      this.addrPost = data.zip;
      this.addrRoad = data.nadr1;
      this.addrCode = data.nnmb;
      this.addrJibun = data.adr1;
      this.addrRemark = '';
    },
    nextStep: function() {
      let vue = this;
      if (this.validate()) {
        let sd = '';
        if (typeof this.date == 'string') {
          sd = this.date;
        } else {
          sd = this.date.getFullYear() + '-' + ('0' + (this.date.getMonth() + 1)).slice(-2) + '-' + ('0' + this.date.getDate()).slice(-2);
        }

        ApiService.service('PUT', 'order/credit', {
          request: {
            creditKey: this.request.orderCommInfo.creditKey,
          },
          serviceType: 'app',
        })
          .then(response => {
            console.log(response);
            if (response.data.isSucceed && response.data.result.resultCode != 1) {
              this.approvalYN = response.data.result.approvalYN;
              this.tightenYN = response.data.result.tightenYN;
              this.rejectYN = response.data.result.rejectYN;
              this.creditErrorYN = response.data.result.errorYN;
              this.creditCompletedYN = response.data.result.completeYN;

              if (this.creditCompletedYN == 'N') {
                this.msg = '신용조회가 아직 끝나지 않았습니다.';
                this.messagePop = true;
              } else {
                if (this.approvalYN == 'Y') {
                  this.resultPage = 'guestStep6';
                } else if (this.tightenYN == 'Y' || this.creditErrorYN == 'Y') {
                  console.log('강화 : ' + this.tightenYN + ', 에러 : ' + this.creditErrorYN);
                  this.resultPage = 'rentalFail';
                } else if (this.rejectYN == 'Y') {
                  console.log('실패');
                  this.resultPage = 'rentalReject';
                }

                let params = this.$route.params.params;

                this.request.installInfo.installUserName = this.customerName;
                this.request.installInfo.installCellNum = this.cellNum;
                this.request.installInfo.installReqDate = sd;
                this.request.orderCommInfo.orderStatus = 'RSTA00RP';
                this.request.orderCommInfo.requestKey = this.request.orderCommInfo.creditKey;
                this.$refs.header.loadingStart(); // 로딩시작
                ApiService.service('POST', 'order/rental', {
                  request: vue.request,
                  serviceType: 'app',
                })
                  .then(response => {
                    if (response.data.isSucceed && response.data.result.resultCode != 1) {
                      if (this.resultPage == 'guestStep6') {
                        params.af_result = '통과';
                      } else {
                        params.af_result = '거절';
                        delete params.af_revenue;
                      }
                      window.appsFlyer('af_rental', params);

                      this.request.orderCommInfo.orderId = response.data.result.orderId;

                      this.$router.push({
                        name: vue.resultPage,
                        params: { request: this.request },
                      });
                    } else {
                      console.log(response);
                      this.msg = response.data.error;
                      this.messagePop = true;
                    }
                  })
                  .catch(response => {
                    console.log(response);
                  })
                  .finally(() => {
                    this.$refs.header.loadingEnd(); // 로딩끝
                  });
              }
            } else {
              console.log(response);
              this.msg = response.data.error;
              this.messagePop = true;
            }
          })
          .catch(response => {
            console.log(response);
            this.msg = response.data.error;
            this.messagePop = true;
          });
      }
    },
    validate: function() {
      if (isEmpty(this.customerName)) {
        this.msg = '이름을 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      if (isEmpty(this.cellNum)) {
        this.msg = '휴대폰번호를 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      /*if (isEmpty(this.installInfo.installAddrRemark)) {
          this.msg = '주소를 입력해주세요.';
          this.messagePop = true;
          return false;
        }
        const chk1 = document.getElementById('terms1_2').checked;
          const chk2 = document.getElementById('terms1_3').checked;

          if (chk1 && chk2) return true;*/
      return true;
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      this.bottomPop = false;
      this.noticePop = false;
      this.webViewPop = false;
      this.sharePop = false;
      this.findAddr = false;
    },
    rental: function() {
      this.msg = GO_HOME;
      this.confirmPop = true;
    },
    cancel: function() {
      // 취소 선택시 팝업 닫기
      this.confirmPop = false;
    },
    confirm: function() {
      // 확인 선택시 장바구니에 담고 페이지이동
      // TODO 장바구니 추가 API 호출
      this.$router.replace('/');
    },
  },
};
</script>
